import BasicsForm from "../components/Create/BasicsForm/BasicsForm";

const Create: React.FC = () => {
  return (
    <div className="w-full h-full flex flex-col items-start">
      <BasicsForm />
    </div>
  );
};

export default Create;
